/**
 * @generated SignedSource<<e1a2417a5738b0a9bc30d5517ec35ec8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCompetitionsCarouselFragment$data = {
  readonly competitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly competition: {
          readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFragment">;
        };
        readonly id: string;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "EventCompetitionsCarouselFragment";
};
export type EventCompetitionsCarouselFragment$key = {
  readonly " $data"?: EventCompetitionsCarouselFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCompetitionsCarouselFragment">;
};

import EventCompetitionsCarouselFragmentPaginationQuery_graphql from './EventCompetitionsCarouselFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "competitions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": EventCompetitionsCarouselFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "EventCompetitionsCarouselFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "competitions",
      "args": null,
      "concreteType": "EventCompetitionConnection",
      "kind": "LinkedField",
      "name": "__EventCompetitionsCarouselFragment_competitions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventCompetitionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventCompetition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Competition",
                  "kind": "LinkedField",
                  "name": "competition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CompetitionCardFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "db01365a2c21e68977a43092ac85e25f";

export default node;
